import { render, staticRenderFns } from "./iKnow.vue?vue&type=template&id=1cf8802d&"
import script from "./iKnow.vue?vue&type=script&lang=js&"
export * from "./iKnow.vue?vue&type=script&lang=js&"
import style0 from "./iKnow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports